/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selected_File_LabelInputs */

const en_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected:`)
};

const fr_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionné :`)
};

const de_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählt:`)
};

const it_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionato:`)
};

const ru_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрано:`)
};

const es_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionado:`)
};

const zh_cn2_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已选：`)
};

const ja_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択済み:`)
};

const hi_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित:`)
};

const pt_pt2_audio_description_export_selected_file_label = /** @type {(inputs: Audio_Description_Export_Selected_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionado:`)
};

/**
* | output |
* | --- |
* | "Selected:" |
*
* @param {Audio_Description_Export_Selected_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selected_file_label = /** @type {((inputs?: Audio_Description_Export_Selected_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selected_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selected_file_label(inputs)
	if (locale === "de") return de_audio_description_export_selected_file_label(inputs)
	if (locale === "it") return it_audio_description_export_selected_file_label(inputs)
	if (locale === "ru") return ru_audio_description_export_selected_file_label(inputs)
	if (locale === "es") return es_audio_description_export_selected_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selected_file_label(inputs)
	if (locale === "ja") return ja_audio_description_export_selected_file_label(inputs)
	if (locale === "hi") return hi_audio_description_export_selected_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selected_file_label(inputs)
	return en_audio_description_export_selected_file_label(inputs)
});